import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        text: String,
        successDuration: { type: Number, default: 2000 },
        originalContent: String
    }

    connect() {
        this.originalContentValue = this.element.innerHTML
    }

    copy(event) {
        event.preventDefault()
        this.copyText(this.textValue)
            .then(() => this.showSuccess())
            .catch(() => this.showError())
    }

    showSuccess() {
        this.element.innerHTML = '<span class="text-green-400 font-bold" role="status" aria-live="polite">¡Copiado!</span>'

        setTimeout(() => {
            this.element.innerHTML = this.originalContentValue
        }, this.successDurationValue)
    }

    showError() {
        this.element.innerHTML = '<span class="text-red-300 font-bold" role="status" aria-live="polite">No se pudo copiar</span>'

        setTimeout(() => {
            this.element.innerHTML = this.originalContentValue
        }, this.successDurationValue)
    }

    async copyText(text) {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text)
            return
        }

        const textarea = document.createElement("textarea")
        textarea.value = text
        textarea.setAttribute("readonly", "")
        textarea.style.position = "absolute"
        textarea.style.left = "-9999px"
        document.body.appendChild(textarea)
        textarea.select()
        const successful = document.execCommand("copy")
        document.body.removeChild(textarea)
        if (!successful) throw new Error("copy_failed")
    }
}
